import { z } from "zod";
import { UserIdPublicSchema } from "./branded-id.schemas.js";
import { E164PhoneNumberSchema } from "./phone.schemas.js";

/**
 * A user linked to one of the event's participants, at the host tier: only the
 * phone a host can reach them on. Clients join it to a participant by
 * `userIdPublic`, so the participant view never carries user data.
 */
export const EventUserEntrySchema = z.object({
  userIdPublic: UserIdPublicSchema,
  whatsappPhone: E164PhoneNumberSchema.nullable(),
});

export const EventUsersSchema = z.object({
  users: z.array(EventUserEntrySchema),
});

export type EventUserEntry = z.infer<typeof EventUserEntrySchema>;
export type EventUsers = z.infer<typeof EventUsersSchema>;
